
<template>
    <el-form label-position="right" label-width="150px"  :inline="inline" :class="className">
        <template v-for="i in fDatas">

        <el-form-item :label="i.nickName" v-if="i.type=='Col' && i.colType=='LineCol' && (i.IsShowCheck===undefined ?true: i.IsShowCheck(entity,i) )">
            <span slot="label"><span class="red" v-if="i.isRequired">*</span> {{i.nickName}}</span>
          
            <template v-for="c in i.colFields" >
                    <el-col :class="c.class"  :span="c.span" v-if="c.type=='SplitText' && (c.IsShowCheck===undefined ?true: c.IsShowCheck(entity,c) )">
                        <label> <span class="red" v-if="c.isRequired">*</span> {{c.nickName}}</label>
                    </el-col>
                    <el-col :span="c.span"  v-if=" (c.IsShowCheck===undefined ?true: c.IsShowCheck(entity,c) )">
                    <span slot="label">  <span class="red" v-if="c.isRequired">*</span> {{c.nickName}}</span>
                        <form-list-item :entity="entity" :field="c" ></form-list-item>
                    </el-col>
            </template>
        </el-form-item>

        <template v-else-if="i.type=='JsonFiled' && (i.IsShowCheck===undefined ?true: i.IsShowCheck(entity,i) )">
            <form-list :entity="entity[i.JsonFiledName]" :fieldData="i.fieldData"></form-list>
        </template>

        <el-form-item :label="i.nickName" v-else-if="i.IsShowCheck===undefined ?true: i.IsShowCheck(entity,i) ">
          <span slot="label">  <span class="red" v-if="i.isRequired">*</span> {{i.nickName}}</span>
            <form-list-item :entity="entity" :field="i"></form-list-item>
        </el-form-item>
        
        </template>
        <slot />
    </el-form>
</template>

<style>
.el-input__inner{
    height: 40px;
    border-radius: 15px;
}
.el-select{
    width: 100%;
}
.el-date-editor.el-input, .el-date-editor.el-input__inner{
    width: 100%;
}
.ql-toolbar.ql-snow .ql-formats{
    line-height :initial;
}
</style>

<script>

import { ToComponentData, CheckByConfig, ToSubmitData ,$Path,$Urlpath} from '../../config/config.js'
import '../../assets/My97DatePicker/WdatePicker.js'

export default {
    props: ['store','fieldData', 'entity','inline','className'],
    data() {
        return {
        
        }
    },
    created() {
    },
    computed: {
        fDatas(){
            return this.store ?this.store.FieldData :  this.fieldData;
        }
    },
    mounted () {
    },
    methods: {
    },
    watch: {
    }
}

</script>





// WEBPACK FOOTER //
// form_list.vue?67cdde50